// extracted by mini-css-extract-plugin
export default {"title":"_737b6468dc","bld":"_5e827ccfec"};